import PropTypes from 'prop-types';
import React from 'react';

import {
    Footer,
    Main,
    Meta,
    SideBar
} from '$partials/global';

import { useLanguage } from '$contexts/language.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ErrorPage = (props) => {
    // hooks
    const { translate: t } = useLanguage();

    // misc
    const status = props.err?.status || 500;

    let message = '';
    let title = '';
    switch(status) {
    case 404:
        message = props.data?.page?.heading404 || `<div class="rich-text"><p>${t('Unfortunately the page you have requested could not be found')}.</p></div>`;
        title = props.data?.page?.heading404 || t('Sorry, we couldn’t find that page.');
        break;

    default:
        message = props.data?.page?.heading500 || `<div class="rich-text"><p>${t('Unfortunately the page you have requested could not be found')}.</p></div>`;
        title = props.data?.page?.heading500 || t('Sorry, something went wrong.');
    }

    const searchDescription = 'Uniplan';
    const titlePretty = title[0].toUpperCase() + title.slice(1);

    // render
    return (
        <>
            <Meta
                description={searchDescription}
                domain={props.domain}
                title={titlePretty}
                url={props.data?.uri} />

            <SideBar
                localePages={props.data?.translations?.edges}
                navigation={props.data?.navigation}
                search={props.data?.search}>
                {/* header */}
                <div className='mt9 sm-mt9 md-mt0 mbn7 sm-mbn7 md-mbn12'>
                    <Main className='container'>
                        {/* content */}
                        <div className='module'>
                            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                                <div className='flex flex-wrap'>
                                    {/* side title */}
                                    <div className='absolute top-0 md-relative md-col-2'>
                                        <div className='px-gutter md-show'>
                                            <h1 className='type-style-5 side-title'>
                                                {status}
                                            </h1>
                                        </div>
                                    </div>

                                    {/* content */}
                                    <div className='col-11 sm-col-8 md-col-7'>
                                        <div className='ml9 sm-ml9 md-ml0'>
                                            <div className='px-gutter'>
                                                {/* title */}
                                                <h2>
                                                    <div
                                                        className='type-style-1 capitalise-first'
                                                        dangerouslySetInnerHTML={{ __html: message }} />
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Main>

                    <Footer { ...props.data?.footer }/>
                </div>
            </SideBar>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    err: PropTypes.object,
    data: PropTypes.shape({
        footer      : PropTypes.object,
        navigation  : PropTypes.object,
        page        : PropTypes.object,
        search      : PropTypes.object,
        translations: PropTypes.object,
        uri         : PropTypes.string
    }),
    domain: PropTypes.string,
};

ErrorPage.propTypes = propTypes;

export { ErrorPage };

export default ErrorPage;
